import React from 'react';
import { FadeIn } from './FadeIn';

export const Hero = () => {
  return (
    <section className="relative min-h-screen bg-c-dark flex flex-col justify-center pt-24 pb-12 overflow-hidden">
      {/* Ambient gradient blobs — atmosphere only */}
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-[10%] right-[-5%] w-[500px] h-[500px] md:w-[600px] md:h-[600px] opacity-15 md:opacity-25"
          style={{
            background: 'conic-gradient(from 0deg at 50% 50%, #25307d, #775788, #ff9999, #b77690, #25307d)',
            borderRadius: '40% 60% 55% 45% / 55% 40% 60% 45%',
            filter: 'blur(80px)',
            animation: 'float 14s ease-in-out infinite',
            willChange: 'transform',
          }}
        />
        <div
          className="absolute bottom-[5%] left-[-10%] w-[350px] h-[350px] md:w-[450px] md:h-[450px] opacity-10 md:opacity-15"
          style={{
            background: 'conic-gradient(from 180deg at 50% 50%, #191e3d, #775788, #dec7ff, #25307d, #191e3d)',
            borderRadius: '55% 45% 40% 60% / 45% 55% 45% 55%',
            filter: 'blur(60px)',
            animation: 'float 18s ease-in-out infinite reverse, pulseGlow 12s ease-in-out infinite',
            willChange: 'transform, opacity',
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full hero-text">
        <div className="max-w-5xl">
          <FadeIn delay={0.1}>
            <p className="text-xs font-medium tracking-super-wide uppercase text-c-powder/40 mb-12 flex items-center gap-4">
              <span className="w-8 h-[1px] bg-c-powder/30 block"></span>
              Strategic Branding & Positioning
            </p>
          </FadeIn>

          <FadeIn delay={0.2}>
            <h1 className="text-5xl md:text-7xl lg:text-[92px] font-light text-white leading-[1.05] tracking-tight mb-12">
              Build a brand that <br className="hidden md:block" />
              <span className="font-serif-italic text-gradient">commands</span> its category.
            </h1>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-start">
            <div className="md:col-span-5 md:col-start-8">
              <FadeIn delay={0.3}>
                <p className="text-lg md:text-xl text-c-powder/60 font-light leading-relaxed mb-10">
                  CHRSMA is a strategic branding and positioning company built for operators — founders and executives who know that clarity is a competitive advantage.
                </p>
                <button
                  onClick={() => { const el = document.getElementById('contact'); if (el) { const offset = window.innerWidth < 768 ? 64 : 80; window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' }); } }}
                  className="inline-flex items-center gap-3 text-xs font-medium tracking-widest uppercase px-8 py-3.5 rounded-xl cta-wire"
                >
                  Start a Conversation
                </button>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
